/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Collapse } from '@mui/material';

import useActiveLink from 'core/hooks/useActiveLink';

import { NavListProps } from '../types';
import NavItem from './NavItem';

type NavListRootProps = {
  data: NavListProps;
  depth: number;
  hasChild: boolean;
};

const NavList: React.FC<NavListRootProps> = ({ data, depth, hasChild }) => {
  const { pathname } = useLocation();
  const { active, isExternalLink } = useActiveLink(data.path);
  const [open, setOpen] = useState(active);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (!active) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={active}
        isExternalLink={isExternalLink}
        onClick={handleToggle}
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  );
};

export default NavList;

type NavListSubProps = {
  data: NavListProps[];
  depth: number;
};

const NavSubList = ({ data, depth }: NavListSubProps) => {
  return (
    <>
      {data.map(list => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
};
